import { FC } from 'react';
import './icons.scss';

interface Props {
  disabled?: boolean;
}

export const ChevronLeft: FC<Props> = ({ disabled = false }) => {
  return (
    <svg
      version="1.1"
      className={getClassNameByStatus(disabled)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <polygon
        fill="currentColor"
        points="10,16 20,6 21.4,7.4 12.8,16 21.4,24.6 20,26 "
      />
      <rect fill="none" width="32" height="32" />
    </svg>
  );
};

export const ChevronRight: FC<Props> = ({ disabled = false }) => {
  return (
    <svg
      version="1.1"
      className={getClassNameByStatus(disabled)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <polygon
        points="22,16 12,26 10.6,24.6 19.2,16 10.6,7.4 12,6 "
        fill="currentColor"
      />
      <rect fill="none" width="32" height="32" />
    </svg>
  );
};

function getClassNameByStatus(disabled: boolean) {
  const className = 'data-breach-icons__icon';
  const status = disabled ? `${className}--disabled` : `${className}--active`;
  return [className, status].join(' ');
}
